module.exports = __webpack_public_path__ + "media/assets/img/flags/nb-NO-fcdf14841cd468de3f43704be16fa303.png";